import {Component, input, output, Pipe, PipeTransform} from '@angular/core';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {HKDateTimePipe} from '../../@common/hkdate.pipe';

interface SensorData {
  sensor_id: string;
  status: string;
  updated_at: Date;
}

@Pipe({
  name: 'sensorNumber',
  standalone: true
})
export class SensorNumberPipe implements PipeTransform {
  transform(sensorId: string): string {
    const match = sensorId.match(/([A-Z]\d{3})/);
    return match ? match[1] : sensorId;
  }
}

@Component({
  selector: 'app-lavatory-result',
  imports: [
    NzButtonComponent,
    NzIconModule,
    HKDateTimePipe,

  ],
  template: `
    @for (r of sensors(); track r.sensor_id) {
      <div [class.occupied]="r.status==='Occupied'" [class.vacant]="r.status==='Unoccupied'" class="sensor-card">
        <div class="sensor-header">
          {{ r.sensor_id }}@if (inspectedCache().has(r.sensor_id)) {
          <span class="inspected-mark">*</span>
        }
        </div>
        <div class="sensor-actions">
          <button (click)="onInspect.emit({sensorId: r.sensor_id, success: true})" nz-button nzType="primary" class="inspect-btn">
            <span nz-icon nzType="check"></span>
          </button>
          <button (click)="onInspect.emit({sensorId: r.sensor_id, success: false})" nz-button nzType="default" nzDanger class="inspect-btn">
            <span nz-icon nzType="close"></span>
          </button>
        </div>
        <div class="sensor-timestamp">{{ r.updated_at | hkdatetime }}</div>
      </div>
    }
  `,
  styles: `
    .sensor-card {
      display: grid;
      grid-template-rows: auto 1fr auto;
      margin: 10px;
      border: 1px solid #87a6ff;
    }

    .sensor-header {
      grid-row: 1;
      padding: 8px 10px;
      font-size: 1rem;
      font-weight: 500;
    }

    .inspected-mark {
      color: #ff4d4f;
      font-weight: bold;
      margin-left: 4px;
    }

    .sensor-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 10px;
    }

    .inspect-btn {
      width: 50px;
      height: 50px;
      font-size: 18px;
    }

    .sensor-timestamp {
      grid-row: 3;
      padding: 6px 10px;
      font-size: 0.5rem;
      color: #666;
    }

    .occupied {
      background: #f8d7da;
    }

    .vacant {
      background: #d4edda;
    }
  `
})
export class LavatoryResultComponent {
  sensors = input.required<SensorData[]>();
  inspectedCache = input.required<Set<string>>();
  onInspect = output<{ sensorId: string, success: boolean }>();
}
